module.exports = __webpack_public_path__ + "img/Surface_of_Water_m.4fb6e10a.svg";